module.exports = __webpack_public_path__ + "static/media/line-size-1.d8a1d01c.svg";